import { render, staticRenderFns } from "./PerfQueryNoId.vue?vue&type=template&id=45d2cb94"
import script from "./PerfQueryNoId.vue?vue&type=script&lang=js"
export * from "./PerfQueryNoId.vue?vue&type=script&lang=js"
import style0 from "./PerfQueryNoId.vue?vue&type=style&index=0&id=45d2cb94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports